/**
 * Rechte der Container-Ansicht — Port von `AfterRefresh()` in `IwmViewBestellposition.razor`.
 * Die Bestellpositions-Seite entscheidet daran, ob sie „New Container“ anbietet.
 */

import { useCallback, useState } from 'react';

import { useAuth } from '@/auth/useAuth';
import type { ChinaAppSysGroupView } from '@/types/entities';
import { EntityTypes } from '@/types/enums';

export interface ContainerPermissions {
  permissions: ChinaAppSysGroupView | null;
  /** Ermittelt die Rechte neu; ohne Container-Ansicht bleibt der Stand unverändert. */
  load: () => void;
}

export function useContainerPermissions(): ContainerPermissions {
  // eslint-disable-next-line @typescript-eslint/unbound-method -- stabile Closures, keine Methoden
  const { getViewIdByEntity, getViewPermissions } = useAuth();
  const [permissions, setPermissions] = useState<ChinaAppSysGroupView | null>(null);

  const load = useCallback(() => {
    const viewId = getViewIdByEntity(EntityTypes.Container);
    if (viewId !== null && viewId > 0) setPermissions(getViewPermissions(viewId));
  }, [getViewIdByEntity, getViewPermissions]);

  return { permissions, load };
}

export default useContainerPermissions;
